import React from "react";
import styles from "./Player.module.scss";

function VideoBackground({ thumbnailUrl }) {
  return <div className={styles.background} style={{ backgroundImage: `url("${thumbnailUrl}")` }} />;
}

export default VideoBackground;
